import type { ReactNode } from "react";

interface Props {
  /** O que se conta. */
  rotulo: string;
  valor: number;
  /**
   * Sobre o que o número foi calculado.
   *
   * <p><b>Obrigatório, e é o ponto do componente.</b> "3 regularizações
   * vencendo" sobre 10 de 300 produtos não informa — engana, e engana quem
   * tem menos contexto para desconfiar.
   */
  base: string;
  /** Percentual de cobertura, quando conhecido. */
  cobertura?: number | undefined;
  tom?: "neutro" | "atencao" | "perigo";
  children?: ReactNode;
}

/**
 * Um número que se explica sozinho.
 *
 * <p>A diretoria abre este painel <b>sem ninguém narrando a tela</b>. Um número
 * solto não informa: convida a interpretar. Por isso o componente não aceita
 * existir sem a base de cálculo — a propriedade é obrigatória por tipo, não por
 * convenção.
 */
export function Indicador({ rotulo, valor, base, cobertura, tom = "neutro", children }: Props) {
  return (
    <div className={`ui-indicador ui-indicador--${tom}`}>
      <span className="ui-indicador__rotulo">{rotulo}</span>
      <strong className="ui-indicador__valor">{valor}</strong>

      <span className="ui-indicador__base">
        {base}
        {cobertura !== undefined && (
          <>
            {" · "}
            <span className="ui-indicador__cobertura">cobertura ~{cobertura}%</span>
          </>
        )}
      </span>

      {children}
    </div>
  );
}
